import React, { useCallback, useMemo, useState } from 'react';
import UDSelect, { SelectOption } from 'ud-form/components/select/component';

import { Search } from 'lucide-react';
import { SingleValue } from 'react-select';
import UDInput from 'ud-form/components/input/component';
import UDPerPage from 'ud-ui/components/per-page/per-page';
import classNames from 'classnames';
import debounce from 'shared/utils/debounce';
import { theme } from 'styles/theme/theme';

type Props = {
  className?: string;
  filters: any;
  years: number[];
  onFilter: (changes: any) => any;
};

const TourneysFilters = (props: Props) => {
  const { filters, years, onFilter, className } = props;
  const [year, setYear] = useState(filters.year);
  const [resultsOnPage, setResultsOnPage] = useState(filters.perPage);

  const yearsOptions = useMemo(() => {
    const options: { label: string; value: number | null }[] = [
      {
        label: 'За все время',
        value: null,
      },
    ];

    years.forEach((year) => {
      options.push({
        label: `${year}`,
        value: year,
      });
    });

    return options;
  }, [years]);

  const defaultValue = useMemo(() => {
    return yearsOptions.find((item) => item.value === year);
  }, [year, yearsOptions]);

  const handleChangeSearch = useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        onFilter({
          ...filters,
          search: e.target.value,
          page: 1,
        });
      }, 500),
    [filters, onFilter],
  );

  const handleChangeYear = useCallback(
    (option: SingleValue<SelectOption>) => {
      onFilter({
        ...filters,
        year: option?.value,
        page: 1,
      });

      setYear(option?.value);
    },
    [filters, onFilter],
  );

  const handleChangeResultsOnPage = useCallback(
    (value: number) => {
      debounce(() => {
        onFilter({
          ...filters,
          perPage: value,
        });
      }, 300)();

      setResultsOnPage(value);
    },
    [filters, onFilter],
  );

  return (
    <div className={classNames('w-full px-6 flex gap-2 py-6', className)}>
      <div className="flex w-2/3 gap-2">
        <div className="w-1/3">
          <UDSelect options={yearsOptions} value={defaultValue} onChange={handleChangeYear} />
        </div>
        <div className="w-2/3">
          <UDInput
            defaultValue={filters.search}
            placeholder="Поиск по турнирам"
            onChange={handleChangeSearch}
            iconProps={{
              position: 'icon-left',
              component: <Search size={16} color={theme.colors.SurfaceRomanSilver30} />,
            }}
          />
        </div>
      </div>
      <div className="w-1/3">
        <UDPerPage value={resultsOnPage} onChange={handleChangeResultsOnPage} />
      </div>
    </div>
  );
};

export default TourneysFilters;
